import { Component, computed, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'cipo-smart-banner',
  imports: [FlexLayoutModule, TranslateModule, MatButtonModule, MatIconModule],
  templateUrl: './smart-banner.component.html',
  styleUrl: './smart-banner.component.scss',
  host: { '[class.visible]': 'visible()' },
})
export class SmartBannerComponent {
  private readonly dismissed = signal(!!sessionStorage.getItem('appBannerDismissed'));
  private readonly testBanner = !!localStorage.getItem('appBannerTest');

  /** True on iOS and Android devices while not dismissed. */
  protected readonly visible = computed(() => {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(ua);
    return (this.testBanner || isAndroid) && !this.dismissed();
  });

  /** Open the deep link directly with an optional browser-test store fallback. */
  openApp(): void {
    const useStoreFallback = !!localStorage.getItem('appBannerBrowserTest');
    const currentUrl = new URL(window.location.href);
    const isAndroid = /android/i.test(navigator.userAgent);

    if (useStoreFallback) {
      window.open(isAndroid ? environment.playStoreUrl : environment.appStoreUrl, '_blank');
      return;
    }

    if (isAndroid) {
      const packageName = (environment.androidPackageName || '').trim();
      const fallbackUrl = encodeURIComponent(environment.playStoreUrl);

      if (packageName && currentUrl.protocol === 'https:') {
        const intentUrl =
          `intent://${currentUrl.host}${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}` +
          `#Intent;scheme=https;package=${packageName};S.browser_fallback_url=${fallbackUrl};end`;

        window.location.assign(intentUrl);
        return;
      }

      window.location.assign(environment.playStoreUrl);
      return;
    }
  }

  /** Dismiss the banner for the remainder of the session. */
  dismiss(): void {
    sessionStorage.setItem('appBannerDismissed', '1');
    this.dismissed.set(true);
  }

  /** Space key should activate the banner action without scrolling the page. */
  onBannerSpace(event: Event): void {
    event.preventDefault();
    this.openApp();
  }
}
